import styled from 'styled-components';

import { CommonInputHelperText } from 'components/common/Forms/Forms.styled';

export const SiteGuidelinesError = styled(CommonInputHelperText)`
  display: block;
  padding: 0;
  font-size: var(--body1);
  line-height: normal;
`;
